import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";

const SocialLinks = () => {
  const links = [
    {
      id: 1,
      child: (
        <>
          Linkedin <FaLinkedin size={30} />
        </>
      ),
      href: "https://linkedin.com/in/oluwaferanmi-adegbola-694932245",
    },

    {
      id: 2,
      child: (
        <>
          GitHub <FaGithub size={30} />
        </>
      ),
      href: "https://github.com/fero-techist",
    },
    {
      id: 3,
      child: (
        <>
          Mail <HiOutlineMail size={30} />
        </>
      ),
      href: "mailto: oluwaferanmiadegbola657@gmail.com",
    },

    {
      id: 4,
      child: (
        <>
          Resume <BsFillPersonLinesFill size={30} />
        </>
      ),
      href: "/Resume.pdf",
      style: "rounded-br-md",
      download: true,
    },
  ];

  return (
    <div className=" hidden lg:flex flex-col top-[35%] left-0 fixed">
      <ul>
        {links.map(({ id, style, href, download, child }) => (
          <li
            key={id}
            // bg-[#2F1893]
            className={
              "flex justify-between items-center max-w-40 h-14 px-4 ml-[-100px] hover:ml-[10px] hover:rounded-md duration-300  bg-gradient-to-r from-cyan-500 to to-gray-700 text-white" +
              " " +
              style
            }
          >
            <a
              href={href}
              className=" flex items-center text-2xl justify-between text-white no-underline gap-2"
              download={download}
              target="_blank"
              rel="noreferrer"
            >
              {child}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SocialLinks;
